import styled, { keyframes } from 'styled-components';
import { COLOR_ORANGE, COLOR_WHITE } from '../../../assets/styles/colors';

const loadingAnim = keyframes`
  0% {
    transform:scale(1);
    opacity: 1;
  }
  75%{
    opacity: .6;
  }
  50%{
    transform:scale(.4);
    opacity: .4;
  }
  100% {
    transform:scale(1);
    opacity: 1;
  }
`;

export default styled.div`
  display: flex;
  width: 80px;
  justify-content: space-between;
  align-items: center;
  &.white {
    div {
      background: ${COLOR_WHITE};
    }
  }
  div {
    margin: 3px;
    height: 10px;
    width: 10px;
    border-radius: 1em;
    background: ${COLOR_ORANGE};
    &:nth-child(1) {
      animation: 1.5s ${loadingAnim} ease infinite;
      animation-delay: 0s;
    }
    &:nth-child(2) {
      animation: 1.5s ${loadingAnim} ease infinite;
      animation-delay: 0.25s;
    }
    &:nth-child(3) {
      animation: 1.5s ${loadingAnim} ease infinite;
      animation-delay: 0.5s;
    }
    &:nth-child(4) {
      animation: 1.5s ${loadingAnim} ease infinite;
      animation-delay: 0.75s;
    }
    &:nth-child(5) {
      animation: 1.5s ${loadingAnim} ease infinite;
      animation-delay: 1s;
    }
  }
`;
